import React, { useState, useEffect, Fragment } from 'react';
import axios from 'axios';
import Box from '../../Box';
import Tools from '../../Tools';

const ClientHeader = (props) => {

    const [client, setClient] = useState(props.client);

    const [phoneList, setPhoneList] = useState([]);
    const [childrenVisible, setChildrenVisible] = useState(false);
    const [callExtraHeaders, setCallExtraHeaders] = useState(null);
    const [addingPhoneToClient, setAddingPhoneToClient] = useState(false);
    const [toggleEditMail, setToggleEditMail] = useState(true);
    const [data, setData] = useState({});

    const handleChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const saveChangesMail=()=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData')); 
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/client`,
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: {
                clientId:props.client._id,
                fieldToChange:"contacto.correo",
                fieldNewValue:data.email
            }
        };

        axios(options).then(response => {
            if(response.data.error===null){
                //update client object (from parent)
                let updatedClient = Object.assign({}, props.client); 
                updatedClient.contacto.correo = data.email; 
                props.updateClientMethod(updatedClient);
                setToggleEditMail(true);
            }
        });

    }

    const addPhoneToClient=()=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData')); 
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/clientPhones`,
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: {
                clientId:props.client.clientId,
                assignmentId:props.campaign.assignmentId,
                availablePhoneNumber:getAvailablePhoneNumber(), 
                phoneNumberToAdd:data.phoneNumberToAdd
            }
        };

        axios(options).then(response => {
            if(response.data.error===null){
                //update client object (from parent)
                let updatedClient = Object.assign({}, props.client); 
                updatedClient.contacto[getAvailablePhoneNumber()] = data.phoneNumberToAdd; 
                props.updateClientMethod(updatedClient);

                //update visually in current component
                const clonedPhoneList = [...phoneList];
                clonedPhoneList.push(data.phoneNumberToAdd);
                setPhoneList(clonedPhoneList);

                data.phoneNumberToAdd=undefined;
                setAddingPhoneToClient(false);
            }
        });

    }
    
    const whatsappMessage =(client)=>{
        axios.get(`http://10.0.0.168:3069/sendwsp`, {
            params: { phone: client.contacto.telefono1, name: `${client.clienteNombre} ${client.clienteApPat}`}
        })
        .then(function (response) {
            alert('Mensaje enviado');
        })
        .catch(function (error) {
            console.log("Error:", error.message);
        });
    }

    const Popover = (props) => {
        if (props.show) {
            return <div className={'popover ' + props.position} style={{ width: props.width }}>{props.children}</div>
        } else {
            return null;
        }
    }

    const getAvailablePhoneNumber=()=>{
        let i=1, available=false, availableNumber='telefono16';
        while (i <= 15 && !available) {
            let currentPhone=props.client.contacto[`telefono${i}`];
            if (currentPhone===undefined || currentPhone===null || currentPhone==="null" || currentPhone===""){
                availableNumber=`telefono${i}`;
                available=true;
            }
            i++;
        }
        return availableNumber;
    }

    useEffect(() => {
        let phoneList=[], i=1;
        while (i <= 15) {
            let currentPhone=props.client.contacto[`telefono${i}`];
            if (currentPhone && currentPhone!==null && currentPhone!=="null" && currentPhone!==""){
                phoneList.push(currentPhone);
            }
            i++;
        }
        
        setPhoneList(phoneList);

        //SET DEFAULT CURRENTPHONE
        let updatedClient = Object.assign({}, props.client); 
        if(props.phone){
            updatedClient.currentPhone=props.phone;
        } else {
            updatedClient.currentPhone = Tools.getPriorityPhone(props.client.contacto);;  
        }
        props.updateClientMethod(updatedClient);
    }, []);

    return (
        <div className="flexRow headerClient">
            <div className="flexCol">

                <Box type="readOnly" className="" name="clientId" label="Rut" value={client.clientId}></Box>
                <Box type="readOnly" className="worb" name="phone" label={'Teléfono (' + phoneList.length + ')'} labelClassName='phoneListTrigger' tooltipLabel="Teléfonos adicionales" value={props.client.currentPhone} showChildren={true} toggleChildrensVisible={() => setChildrenVisible(!childrenVisible)} childrenVisible={childrenVisible}>
                    <div className='phoneList'>
                        <ol>
                            {phoneList.map((phone, index) => {
                                return (
                                    <li className={phone===props.client.currentPhone?'selected':undefined} key={index}><a onClick={() => { let updatedClient = Object.assign({}, props.client); updatedClient.currentPhone = phone; props.updateClientMethod(updatedClient); setChildrenVisible(!childrenVisible); }}>{phone}</a></li>
                                );
                            })}
                        </ol>
                        <hr className="sep" />
                        {!addingPhoneToClient?(
                        <button onClick={()=>setAddingPhoneToClient(true)}>Agregar Teléfono</button>):
                        (<Fragment>
                            <input name="phoneNumberToAdd" className={data.phoneNumberToAdd && data.phoneNumberToAdd.length<11?'invalid':'valid'} placeholder="56900000000" maxLength={11} type="text" onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()} onChange={handleChange}/>
                            <div className="flexRow buttonGroup">
                                <button disabled={!data.phoneNumberToAdd || (data.phoneNumberToAdd && data.phoneNumberToAdd.length<11)} onClick={addPhoneToClient}>Aceptar</button>
                                <button onClick={()=>setAddingPhoneToClient(false)}>Cancelar</button>
                            </div>
                        </Fragment>
                        )}
                    </div>
                </Box>
                
                <Box type="readOnly" className="x4" name="address" label="Dirección" value={client.direccion.detalle + client.direccion.comuna}></Box>
                {/* <Box type="readOnly" className="x3" name="email" label="Email" value={client.contacto.email}></Box> */}
                
                {toggleEditMail?(
                    <Box type="readOnly" fieldType="CONTENT" className="x3" name="email" label="Email" value={client.contacto.correo}>
                        <div className="buttonsWrapper"><button className="micro" onClick={()=>setToggleEditMail(!toggleEditMail)}>editar</button></div>
                    </Box>
                ):(
                    <Box type="text+content" name="email" label="email" className="x3" placeholder="Ingrese ..." value={client.contacto.correo} onChange={handleChange}>
                        <div className="buttonsWrapper">
                            {data.email?(
                                <button className="micro" onClick={()=>saveChangesMail()}>Guardar</button>
                            ):null}
                            <button className="micro" onClick={()=>setToggleEditMail(!toggleEditMail)}>Cancelar</button>
                        </div>
                    </Box>
                )}


            </div>
        </div>
    );

}

export default ClientHeader;
